import { readerImage } from '@/asset/js/utils';
import {
  fetchLuckyDrawList,
  fetchLuckyDrawRank,
  fetchLuckyDraw,
  fetchLuckyDrawFloat,
  offDialogLuckDraw,
  remainTimeLuckDraw,
  drawRewardList,
  getDrawReward,
  luckDrawItemList,
  luckDrawExchange,
  luckDrawExchangeDetail,
} from '@/services/activity';
import { Toast } from 'antd-mobile';

export default {
  namespace: 'luckyDarw',
  state: {
    awardList: [],
    rankList: [],
    remainTimes: 0,
    resetTime: 0,
    endTime: '',
    startTime: '',
    status: 0,
    giftList: [],
    rules: '',
    titleUrl: '',
    floatIcon: '',
    coinValue: '',
    coinRank: [],
    activityType: 0,
    disableDialog: null,
    currentDrawCount: 0,
    drawRewardList: [],
    lastId: '',
    totalRewards: [],
    selfInfo: {},
    currentTicket: 0,
    shopItems: [],
    pageNum: 1,
    pageSize: 20,
    recordList: [],
    isMore: false,
  },
  reducers: {
    updateAwardList(state, { payload }) {
      return {
        ...state,
        awardList: payload.awardList || [],
        resetTime: payload.resetTime || 0,
        endTime: payload.endTime || '',
        startTime: payload.startTime || '',
        status: payload.status || 0,
        giftList: payload.giftList || [],
        rules: payload.rules || '',
        titleUrl: payload.titleUrl || '',
        floatIcon: payload.floatIcon || '',
        coinValue: payload.coinValue || 0,
        coinRank: payload.coinRank || [],
        activityType: payload.activityType || 0,
        disableDialog: payload.disableDialog || false,
      };
    },
    updateRankList(state, { payload }) {
      const { totalRewards, activityRankVO, force } = payload;
      let list = force ? [] : [...state.rankList];
      let selfInfo = {};
      let lastId = '';
      if (activityRankVO && activityRankVO.ranks && activityRankVO.ranks.length) {
        list = [...list, ...activityRankVO.ranks];
        lastId = activityRankVO.ranks[activityRankVO.ranks.length - 1].userId;
      }
      if (activityRankVO && activityRankVO.selfInfo && activityRankVO.selfInfo.userId) {
        selfInfo = activityRankVO.selfInfo;
      }
      return {
        ...state,
        totalRewards,
        rankList: list,
        selfInfo: selfInfo,
        lastId: lastId,
      };
    },
    updateRemainTimes(state, { payload = [] }) {
      return {
        ...state,
        remainTimes: payload.remainNum || 0,
      };
    },
    updateDiaLog(state, { payload = [] }) {
      return {
        ...state,
        disableDialog: payload.disableDialog,
      };
    },
    updateProcessList(state, { payload }) {
      return {
        ...state,
        currentDrawCount: payload.currentDrawCount || 0,
        drawRewardList: payload.drawRewardList || [],
      };
    },
    updateItemList(state, { payload = {} }) {
      return {
        ...state,
        currentTicket: payload.currentTicket || 0,
        shopItems: payload.shopItems || [],
      };
    },
    updateRemainTicket(state, { payload = {} }) {
      return {
        ...state,
        currentTicket: payload.score || 0,
      };
    },
    updateRecordList(state, { payload }) {
      let newList = payload.force ? [] : [...state.recordList];
      if (payload.records && payload.records.length) {
        newList = [...newList, ...payload.records];
      }
      return {
        ...state,
        recordList: newList,
        pageNum: payload.pageNum,
        isMore: payload.records.length === 20,
      };
    },
  },
  effects: {
    *getRankList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.luckyDarw);
      const { data, error } = yield call(fetchLuckyDrawRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error) {
        yield put({
          type: 'updateRankList',
          payload: [],
        });
        return error;
      }
      yield put({
        type: 'updateRankList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *draw({ payload }, { call }) {
      const { error, data, code } = yield call(fetchLuckyDraw, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *offDialog({ payload }, { call }) {
      const { error, data, code } = yield call(offDialogLuckDraw, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *getLuckyDrawList({ payload }, { call, put }) {
      const { data, error } = yield call(fetchLuckyDrawList, payload);
      if (error) {
        yield put({
          type: 'updateAwardList',
          payload: {},
        });
        Toast.show({
          content: error,
        });
        return error;
      }
      if (data) {
        for (let i = 0; i < data.awardList.length; i++) {
          const { width, height } = yield readerImage(data.awardList[i].image);
          let w = 49;
          let h = 49;
          let t = 3;
          if (width > height) {
            h = (height / width) * w;
            t = (50 - h) / 2 + t;
          } else if (width < height) {
            w = (width / height) * h;
          } else {
            w = 49;
            h = 49;
          }
          data.awardList[i].w = w;
          data.awardList[i].h = h;
          data.awardList[i].t = t;
        }
        yield put({
          type: 'updateAwardList',
          payload: { ...data },
        });
      }
      return true;
    },
    *getRemainTimes({ payload }, { call, put }) {
      const { data, error } = yield call(remainTimeLuckDraw, payload);
      if (error) {
        yield put({
          type: 'updateRemainTimes',
          payload: {},
        });
        Toast.show({
          content: error,
        });
        return error;
      }
      if (data) {
        yield put({
          type: 'updateRemainTimes',
          payload: { ...data },
        });
      }
      return true;
    },
    *getDialog({ payload }, { call, put }) {
      const { data, error } = yield call(fetchLuckyDrawList, payload);
      if (error) {
        yield put({
          type: 'updateDiaLog',
          payload: {},
        });
        Toast.show({
          content: error,
        });
        return error;
      }
      if (data) {
        yield put({
          type: 'updateDiaLog',
          payload: { ...data },
        });
      }
      return true;
    },
    *getDrawFloatList({ payload }, { call }) {
      const { error, data } = yield call(fetchLuckyDrawFloat, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return {
          success: true,
          data: data.length ? data : [],
        };
      } else {
        return false;
      }
    },
    *getProcessList({ payload }, { call, put }) {
      const { data, error } = yield call(drawRewardList, payload);
      if (error) {
        yield put({
          type: 'updateProcessList',
          payload: {},
        });
        return error;
      }
      yield put({
        type: 'updateProcessList',
        payload: data || {},
      });
      return true;
    },
    *getGifts({ payload }, { call }) {
      const { error, data, code } = yield call(getDrawReward, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *getItemList({ payload }, { call, put }) {
      const { data, error } = yield call(luckDrawItemList, payload);
      if (error) {
        yield put({
          type: 'updateItemList',
          payload: {},
        });
        Toast.show({
          content: error,
        });
        return error;
      }
      if (data) {
        yield put({
          type: 'updateItemList',
          payload: { ...data },
        });
      }
      return true;
    },
    *exchangeLuckyDraw({ payload }, { call, put }) {
      const { data, error } = yield call(luckDrawExchange, payload);
      if (error) {
        // yield put({
        //   type: 'updateRemainTicket',
        //   payload: {},
        // });
        Toast.show({
          content: error,
        });
        return error;
      }
      if (data) {
        yield put({
          type: 'updateRemainTicket',
          payload: { ...data },
        });
      }
      return { data, success: true };
    },
    *getLuckyDrawExchangeDetail({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.luckyDarw);
      const { error, data } = yield call(luckDrawExchangeDetail, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateRecordList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRecordList',
        payload: { records: data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force },
      });
      return true;
    },
  },
};
